<template>
  <div>
    <div v-if="isLoadingConversations" class="spinner-container">
          <div class="spinner"></div>
        </div>
      <Conversations ref="conversations" class="atendimento-conversations"
      :conversations="conversations"
      :person="personDetails"
        @changeTab="handleTabChange"
        @sendUpdateOperator="updataOperator"
        @sendAssumeOperator="assumeConversation"
        @loading-changed="handleLoadingChanged"
        />
        <div class="row" v-show="!isLoadingConversations && !conversations.length">
        <div class="col-12 pt-3 pb-3 pl-3">
          <h4 class="ml-5">Não possui atendimentos</h4>
        </div>
      </div>
        <div class="pagination-controls">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li class="page-item"><a  @click="previousPage" :disabled="currentPage <= 1" class="page-link" href="#">Anterior</a></li>
              <li :class="['page-item', { 'active': currentPage === page }]" v-for="page in displayedPages" :key="page">
                <a @click="goToPage(page)" :class="{'page-link': true, 'active': page === currentPage}" href="#">{{ page }}</a>
              </li>
              <li class="page-item"><a @click="nextPage" :disabled="currentPage >= totalPages" class="page-link" href="#">Próximo</a></li>
              <ul class="pagination justify-content-center">
                  <span class="page-link ">
                    {{ currentPage }} de {{ totalPages }}
                  </span>
              </ul>
            </ul>
          </nav>
    </div>
      </div>
</template>
<script>
import Conversations from './components/conversations/Conversations.vue'
// import { JWTService } from '@/shared/services/jwt'

// import _ from 'lodash'

import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'Atendimento',
  components: {
    Conversations
  },
  mixins: [AccountMixin],
  computed: {
    displayedPages: function () {
      var pages = []
      var startPage = Math.max(1, this.currentPage - Math.floor(this.pagesToShow / 2))
      var endPage = Math.min(this.totalPages, startPage + this.pagesToShow - 1)

      if (endPage - startPage + 1 < this.pagesToShow) {
        startPage = Math.max(1, endPage - this.pagesToShow + 1)
      }

      for (var i = startPage; i <= endPage; i++) {
        pages.push(i)
      }

      return pages
    }
  },
  data () {
    return {
      isLoadingConversations: false,
      conversationsSubscription: null,
      conversations: [],

      countConversation: 0,

      conversationSubscription: null,
      conversationDispatchesSubscription: null,
      conversation: {
        conversationId: null,
        identifier: null
      },

      isLoadingMessages: false,
      messages: [],

      stompClient: null,

      isLoading: false,
      isConnected: false,
      currentPage: this.$route.query.page || 1,
      pageSize: 9,
      totalPages: 0,
      pagesToShow: 3
    }
  },
  mounted () {
    this.connect()
  },
  beforeDestroy () {
    this.disconnect()
  },
  methods: {
    connect () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`)
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, frame => {
        this.isConnected = true
        this.getConversations()
      }, error => {
        this.isConnected = false
        console.error('Connection error: ' + error)
      })
    },
    getDuration (conversation) {
      const startDate = new Date(conversation.dateOpen)
      const endDate = new Date(conversation.dateFinalization)
      const duration = endDate - startDate
      const durationInMinutes = duration / 1000 / 60
      return durationInMinutes
    },
    disconnect () {
      if (this.stompClient !== null) {
        this.stompClient.disconnect()
      }
    },
    refreshPage () {
      location.reload()
    },
    // Interaction methods
    handleTabChange () {
      this.conversations = []
      this.getConversations()
    },
    assumeConversation (payload) {
      this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
      this.refreshPage()
    },
    clearConversations () {
      this.conversations = []
    },
    previousPage () {
      this.clearConversations()
      if (this.currentPage > 1) {
        this.currentPage--
        this.$router.push('/atendimento/historico?page=' + this.currentPage)
        this.refreshPage()
      }
    },
    nextPage () {
      this.clearConversations()
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.$router.push('/atendimento/historico?page=' + this.currentPage)
        this.refreshPage()
      }
    },
    async getPages () {
      const requestConfig = {
        params: {
          status: 'Finalizado',
          operatorId: 'all'
        }
      }

      await AtendimentoRepository.GetPages(requestConfig)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            console.log(data)
            this.countsConversation = data
            this.totalPages = Math.ceil(data / this.pageSize)
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    getPa () {
      // Verifica se `account`, `funcionario`, e `paId` existem antes de tentar acessar `paId[0]`
      if (this.account && this.account.funcionario) {
        if (this.account.funcionario.paId) {
          return this.account.funcionario.paId[0]
        }
      }
      return 'all'
    },
    async getConversations () {
      this.handleLoadingChanged(true)
      const requestConfig = {
        params: {
          status: 'Finalizado',
          operatorId: 'all',
          page: this.currentPage,
          pageSize: this.pageSize
        }
      }
      const pa = this.getPa()
      if (pa) {
        requestConfig.params.deptoId = pa
      }
      await this.getPages()
      console.log(this.countConversation)

      await AtendimentoRepository.GetConversations(requestConfig)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            console.log(data)
            this.conversations = data
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    updataOperator (payload) {
      this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
      this.refreshPage()
    },
    handleLoadingChanged (isLoading) {
      this.isLoadingConversations = isLoading
    }
  }
}
</script>

<style lang="scss" scoped>
.atendimento-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .atendimento-nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    padding: 0 1rem;
    margin-bottom: 5px;
    border-bottom: solid 1px #e6e6e6;
    background-color: #fff;

    span {
      color: #006a5b !important;
      font-weight: 700;
      font-size: 16px;
    }
  }

  .atendimento {
    display: flex;
    height: 100%;

    .atendimento-conversations {
      width: 20% !important;
      max-width: 20%;
      min-width: 300px;
    }

    .atendimento-chat {
      width: 60% !important;
      min-width: 300px;
    }

    .atendimento-detail {
      width: 20% !important;
      max-width: 25%;
      min-width: 300px;
    }
  }
  .spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1BACA0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/historico_atendimento/historicoAtendimento.vue